/* Reuse the theme's price, cart, URL and gallery behavior for this product only. */
customElements.whenDefined('pdp-variants-component').then(() => {
  if (customElements.get('leather-option-picker')) return;
  const PdpVariants = customElements.get('pdp-variants-component');
  class LeatherOptionPicker extends PdpVariants {
    connectedCallback() {
      // Keep the purchase fields directly after the choices; product facts follow.
      const actions = this.section.querySelector('.pdp__actions');
      const features = this.section.querySelector('.pdp__features');
      if (actions && features) actions.after(features);
      this.onChoice = this.handleChoice.bind(this);
      this.onVariant = (event) => {
        if (event.target.closest('.pdp') === this.section) this.updateActiveVariant(event);
      };
      this.addEventListener('change', this.onChoice);
      document.addEventListener('theme:variant:update', this.onVariant);
      this.mainSwiper = this.section.querySelector('.gallerySwiperMain')?.swiper || null;
      this.loadProductData();
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChoice);
      document.removeEventListener('theme:variant:update', this.onVariant);
      clearTimeout(this.gallerySyncTimeout);
      this.gallerySyncTimeout = null;
    }

    handleChoice(event) {
      if (!event.target.matches('input[data-option-index]')) return;
      const options = Array.from(this.querySelectorAll('fieldset')).map(field => field.querySelector('input:checked')?.value);
      const variant = this.productData?.variants.find(item => item.options.every((value, index) => value === options[index]));
      if (!variant) {
        // Never leave an old, purchasable variant ID behind for a missing combination.
        this.variantIdInput.value = '';
        this.updateAvailability(null);
        this.updateChoices(options);
        const button = this.getAddToCartButton();
        if (button) button.textContent = 'Unavailable';
        this.showStatus('This combination is unavailable. Choose another option.');
        return;
      }
      this.variantIdInput.value = variant.id;
      this.updateActiveState(String(variant.id));
      this.updateProductDetails(String(variant.id));
    }

    updateActiveState(variantId) {
      const variant = this.productData?.variants.find(item => String(item.id) === String(variantId));
      if (!variant) return;
      this.querySelectorAll('fieldset').forEach(field => { field.disabled = false; });
      this.dataset.ready = 'true';
      this.querySelectorAll('input[data-option-index]').forEach(input => {
        input.checked = input.value === variant.options[Number(input.dataset.optionIndex)];
      });
      this.updateChoices(variant.options);
      this.showStatus(this.isVariantSoldOut(variant) ? 'This combination is sold out. Choose another option.' : '');
    }

    updateChoices(options) {
      this.querySelectorAll('[data-selected-value]').forEach(label => {
        label.textContent = options[Number(label.dataset.selectedValue)];
      });
      this.querySelectorAll('input[data-option-index]').forEach(input => {
        const index = Number(input.dataset.optionIndex);
        const candidate = this.productData.variants.find(item => item.options.every((value, i) => value === (i === index ? input.value : options[i])));
        const unavailable = !candidate || this.isVariantSoldOut(candidate);
        // Keep the choice selectable so customers can reach another available combination.
        const label = input.closest('label');
        label.dataset.unavailable = String(unavailable);
        label.title = input.value + (unavailable ? ' - Unavailable with the other selected options' : '');
        input.setAttribute('aria-label', label.title);
        const img = label.querySelector('img');
        if (img && candidate?.featured_image?.src) {
          const url = new URL(candidate.featured_image.src, location.origin);
          url.searchParams.set('width', '200');
          img.removeAttribute('srcset');
          img.src = url.href;
        }
      });
    }

    showStatus(message) {
      const status = this.querySelector('.leather-options__status');
      status.textContent = message;
      status.hidden = !message;
    }
  }
  customElements.define('leather-option-picker', LeatherOptionPicker);
});
